import React from 'react';
import { useNavigation } from './NavigationContext';
import { navigationData } from '../../data/navigationData';
import { NavigationItem } from '../../types/navigation';
import './ProductNavigation.css';

const ProductNavigation: React.FC = () => {
  const { state, updateState } = useNavigation();

  const handleProductNavigation = (item: NavigationItem) => {
    if (item.external) {
      window.open(item.href, '_blank');
      return;
    }

    const pathParts = item.href.split('/');
    const page = pathParts[pathParts.length - 1] || 'overview';
    
    updateState({
      page: page,
      path: item.href
    });
  };

  const getProductIcon = (productKey: string) => {
    switch (productKey) {
      case 'leads':
        return (
          <path d="M13 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM14 15a4 4 0 0 0-8 0v1h8v-1ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM16 18v-1a5.972 5.972 0 0 0-.75-2.906A3.005 3.005 0 0 1 19 17v1h-3ZM4.75 14.094A5.973 5.973 0 0 0 4 17v1H1v-1a3.005 3.005 0 0 1 3.75-2.906Z" fill="currentColor"/>
        );
      case 'calls':
        return (
          <path d="M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.037 11.037 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.435.74a1 1 0 0 1 .836.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3z" fill="currentColor"/>
        );
      case 'programs':
        return (
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 0 0 .95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 0 0-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 0 0-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 0 0-.364-1.118L2.98 8.719c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 0 0 .951-.69l1.07-3.292z" fill="currentColor"/>
        );
      case 'finance':
        return (
          <path d="M4 4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4zm2 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zm0 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1z" fill="currentColor"/>
        );
      case 'agency':
        return (
          <path d="M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4zm8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 4a4 4 0 0 0-3.207 1.593A1 1 0 0 0 7.584 16h4.833a1 1 0 0 0 .79-1.407A4 4 0 0 0 10 13z" fill="currentColor"/>
        );
      default:
        return null;
    }
  };

  if (!state.product || state.section !== 'pros') return null;

  const productData = navigationData.products[state.product];
  if (!productData) return null;

  return (
    <nav className="product-nav" role="navigation" aria-label="Product-specific navigation">
      <div className="container">
        <div className="product-nav-content">
          <div className="product-nav-title">
            {state.demoSettings.showProductLogos && (
              <div className="product-nav-logo">
                <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {getProductIcon(state.product)}
                </svg>
              </div>
            )}
            <h2>{productData.title}</h2>
          </div>
          <div className="product-nav-items">
            {productData.items.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`product-nav-item ${item.external ? 'external' : ''} ${
                  item.href === state.path ? 'active' : ''
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleProductNavigation(item);
                }}
                {...(item.external && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ProductNavigation;